import { useBreakpoint } from '@pelckmans/elementis/contexts/BreakpointsContext';
import AdminMenu from '../../sidebar/AdminMenu';
import PelckmansLogo from '../../sidebar/components/PelckmansLogo';
import User from '../../sidebar/components/User';
import MethodNavigation from './components/MethodNavigation';

export default function PageNavigation({ onClick }: { onClick?: () => void }) {
  const breakpoint = useBreakpoint();

  return (
    <aside className="page-navigation" id="page-navigation">
      <div className="content">
        {breakpoint !== 'mobile' && (
          <div className="top-navigation">
            <PelckmansLogo />
          </div>
        )}
        <div className="middle-navigation">
          <MethodNavigation iconOnly={breakpoint !== 'mobile'} onClick={onClick} />
        </div>
        {breakpoint !== 'mobile' && (
          <div className="bottom-navigation" data-testid="bottom-navigation">
            <AdminMenu />
            <User />
          </div>
        )}
      </div>
    </aside>
  );
}
